import { http } from "../../request.js";
function getUserInfo() {
  let data = {};
  sessionStorage.getItem("userInfo")
    ? (data = JSON.parse(sessionStorage.getItem("userInfo")))
    : (data = {});
  return data;
}

export default {
  //患者详情数据统计
  dataStatistics(data) {
    return http.post("/gluce/dataManager", data);
  },
  //患者详情-历史记录
  dataHistory(data) {
    return http.post("/gluce/dataManagerHistory", data);
  },
  //患者详情-分析报告列表
  reportPage(data) {
    return http.postForm("/gluce/reportPage", data);
  },
  //患者详情-生成分析报告
  generateReport(data) {
    return http.postForm("/gluce/generateReport", data);
  }
};

